// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/RecebimentoOperadores_BuscaDadosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /relatorios/recebimento_operadores/buscaDados
 *
 * Returns a list of per-operador-per-franquia aggregates. Each row carries
 * three fixed labels (`Nome`, `Franquia`, `Total`) plus one numeric column
 * per active forma de pagamento — those keys are determined at runtime
 * from Formas_pagamento_model::selectXcrudFormasPagamento(), so the row
 * is genuinely shape-erased (Record<string, string|number>) and cannot be
 * narrowed to a Row class.
 *
 * @see Recebimento_operadores_model::buscaDados()
 * @see Formas_pagamento_model::selectXcrudFormasPagamento()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type RecebimentoOperadores_BuscaDadosResponseDados = Record<string, string | number>[];

export type RecebimentoOperadores_BuscaDadosResponse = ApiResponse<RecebimentoOperadores_BuscaDadosResponseDados>;

registerResponseContract('RecebimentoOperadores_BuscaDadosResponse', {})
